const HeroSection = () => {
  return (
    <section className="min-h-screen relative overflow-hidden pt-24">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/billing1.avif" 
          alt="Medical Billing Background" 
          className="w-full h-full object-cover"
        />
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 right-20 w-64 h-64 border border-white/30 rounded-full"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 border border-white/30 rounded-full"></div>
        <div className="absolute top-1/2 right-1/4 w-32 h-32 border border-white/30 rounded-full"></div>
        <div className="absolute top-1/3 left-1/3 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>

      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8  relative z-10">
        <div className="flex items-center min-h-[calc(100vh-6rem)]">
          {/* Content */}
          <div className="text-white space-y-8 max-w-4xl">
            {/* Badge */}
            <div className="hidden md:inline-flex items-center bg-white/20 backdrop-blur-md border border-white/30 text-white px-6 py-2 rounded-full text-base font-bold shadow-lg">
              <span className="mr-2">🏆</span>
              #1 MEDICAL BILLING SERVICES IN USA
            </div>

            {/* Main Heading */}
            <div className="space-y-1">
              <h1 className="text-5xl md:text-5xl lg:text-5xl font-bold leading-tight">
                Your Trusted Medical Billing Partner in <span className="relative inline-block">
                  USA
                  <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 15 Q 50 5, 100 15 T 200 15" stroke="currentColor" strokeWidth="8" fill="none" className="text-blue-500" strokeLinecap="round"/>
                  </svg>
                </span>
              </h1>
              
            </div>

            {/* Description */}
            <div className="space-y-6 text-lg lg:text-xl text-white leading-relaxed">
              <p>
                iSolve RCM is a leading medical billing services provider in the USA, 
                delivering accurate, compliant, and results-driven revenue cycle 
                management solutions for healthcare providers.
              </p>
              <p>
                Our experienced team of certified medical billers and coders works 
                closely with physicians, clinics, and healthcare organizations to 
                streamline billing.
              </p>
            </div>

            {/* Contact Form */}
            <div className="pt-4">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
                <input
                  type="text"
                  placeholder="Name"
                  className="px-6 py-4 rounded-xl border-2 border-white/40 bg-transparent text-white placeholder-white/80 text-lg focus:outline-none focus:border-white transition-colors"
                />
                <input
                  type="email"
                  placeholder="Email"
                  className="px-6 py-4 rounded-xl border-2 border-white/40 bg-transparent text-white placeholder-white/80 text-lg focus:outline-none focus:border-white transition-colors"
                />
                <input
                  type="tel"
                  placeholder="Phone"
                  className="px-6 py-4 rounded-xl border-2 border-white/40 bg-transparent text-white placeholder-white/80 text-lg focus:outline-none focus:border-white transition-colors"
                />
                <button className="bg-white text-blue-600 font-bold px-6 py-4 rounded-xl hover:bg-gray-100 transition-colors shadow-lg text-lg">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
